<template>
  <transition name="nav-bar-anim">
    <div class="nav-bar" v-if="showNavBar && !showMenuOpen">
      <div class="nav-bar-container">
        <router-link :to="backTo" class="nav-bar-button">
          <div class="nav-bar-button-icon"></div>
          <div class="nav-bar-button-name">{{ buttonName }}</div>
        </router-link>
        <div class="nav-bar-title">{{ title }}</div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "News",
  props: {
    title: String,
    buttonName: String,
    backTo: String
  },
  computed: mapGetters(["showNavBar", "showMenuOpen"])
};
</script>

<style lang="scss">
.nav-bar {
  position: fixed;
  top: 80px;
  left: 0;
  right: 0;
  background-color: $pink;
  z-index: 99;
  .nav-bar-container {
    position: relative;
    max-width: 1480px;
    margin: 0 auto;
    padding: 10px 200px;
  }
  .nav-bar-button {
    position: absolute;
    top: 50%;
    left: 50px;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    .nav-bar-button-icon {
      transform: translateX(50%);
      margin-right: 15px;
      &:before {
        content: "";
        position: relative;
        top: 2px;
        display: block;
        width: 8px;
        height: 8px;
        border-bottom: 2px solid $white;
        border-left: 2px solid $white;
        transform: rotate(45deg);
        transform-origin: 50% 0 0;
      }
    }
    .nav-bar-button-name {
      @include josefinsans-regular;
      font-size: 16px;
      line-height: 18px;
      text-transform: uppercase;
    }
  }
  .nav-bar-title {
    @include josefinsans-regular;
    flex: 1;
    text-align: center;
    font-size: 16px;
    text-transform: uppercase;
  }
}
@media (max-width: $mobile) {
  .nav-bar {
    .nav-bar-container {
      padding: 10px 5%;
      padding-left: 10%;
    }
    .nav-bar-button {
      left: 5%;
      .nav-bar-button-name {
        display: none;
      }
    }
    .nav-bar-title {
      font-size: 14px;
    }
  }
}
.nav-bar-anim-enter-active,
.nav-bar-anim-leave-active {
  transition: opacity 0.5s;
}
.nav-bar-anim-enter,
.nav-bar-anim-leave-to {
  opacity: 0;
}
</style>